import { IconButton, Popover } from '@workramp/ui';
import { useEffect, useState } from 'react';
import { I18n } from '~/common/explicit-exports';
import NotificationContent from '~/components/navigation/NotificationContent';
import NotificationsApi from '~/agent/notifications';
import { NotificationWrapper } from './NotificationsNavItem.styles';

const NOTIFICATION_POPOVER_WIDTH = 400;
const TRANSLATED_NOTIFICATIONS = I18n.t('js.learner.notifications.dropdown.heading');

export interface NotificationsNavItemProps {
  userId: number;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export function NotificationsNavItem({ userId, isOpen, onOpenChange }: NotificationsNavItemProps) {
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);

  useEffect(() => {
    NotificationsApi.getNotificationCount(userId, ({ unread }: { unread: number }) => {
      setUnreadNotificationCount(unread);
    });
  }, [userId]);

  return (
    <NotificationWrapper $hasIndicator={unreadNotificationCount > 0}>
      <Popover
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="bottom-end"
        width={NOTIFICATION_POPOVER_WIDTH}
        title={TRANSLATED_NOTIFICATIONS}
        buttonEl={
          <IconButton
            variant="text"
            color="secondary"
            iconName="notification:regular"
            label={TRANSLATED_NOTIFICATIONS}
            size="lg"
            tooltip={{
              message: TRANSLATED_NOTIFICATIONS,
              placement: 'bottom-end',
            }}
          />
        }
      >
        <NotificationContent user={{ id: userId }} updateNavUnreadNotificationCount={setUnreadNotificationCount} />
      </Popover>
    </NotificationWrapper>
  );
}
